import ProgressStepper, { Step } from '@carvana/ds-progress-stepper';
import styles from './ProgressBar.module.css';

const PROGRESS_STEPS = [
  { label: 'Vehicle inspection' },
  { label: 'Reconditioning and detailing' },
  { label: 'Your exclusive preview' }
];

const getStepState = (
  stepIndex: number,
  currentStep: number
): Step['state'] => {
  const stepNumber = stepIndex + 1;

  if (stepNumber === currentStep) return 'active';
  if (stepNumber < currentStep) return 'complete';

  return 'inactive';
};

type OwnProps = {
  currentStep: number;
};

export default function ProgressBar({ currentStep }: OwnProps) {
  const steps = PROGRESS_STEPS.map((step, index) => ({
    ...step,
    state: getStepState(index, currentStep)
  }));

  return <ProgressStepper className={styles.progressStepper} steps={steps} />;
}
